// extracted by mini-css-extract-plugin
export var ctaButton = "CtaButton-module--cta-button--38tUI";